module.exports = __webpack_public_path__ + "static/media/primary-secondary-logos.c52c895c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/primary-secondary-logos.png
// module id = 1300
// module chunks = 0